import React, { useContext, useState, useEffect } from "react";
import {
  Grid,
  Card,
  CardContent,
  Box,
  Skeleton,
  Typography,

} from "@mui/material";
import { styled } from "@mui/material/styles";
import { useNavigate, useParams } from "react-router-dom";
import SearchOffIcon from "@mui/icons-material/SearchOff";
import { KnowledgeBaseContext } from "../../components/knowledgeBaseContext/KnowledgeBaseContext";
import { COLORS, fontFamilyAll } from "../../assets/commonComponents/COLORS";

const StyledCard = styled(Card)(({ theme }) => ({
  width: 300,
  height: 170,
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  transition: "transform 0.25s ease, box-shadow 0.25s ease",
  borderRadius: theme.shape.borderRadius * 2,
  cursor: "pointer",
  "&:hover": {
    transform: "translateY(-4px)",
    boxShadow: theme.shadows[6],
  },
}));

const StyledSkeletonCard = styled(Card)(({ theme }) => ({
  width: 300,
  height: 170,
  borderRadius: theme.shape.borderRadius * 2,
}));

function ArticlePage() {
  const navigate = useNavigate();
  const { id, search } = useParams();
  const [loading, setLoading] = useState(true);

  const { categories, setCategoryId, searchString, setSearchString, setSelectedRecordid } =
    useContext(KnowledgeBaseContext);

  const [articlesList, setArticlesList] = useState([]);
  const [categoryName, setCategoryTitle] = useState("");

  useEffect(() => {
    if (categories.length > 0) {
      setLoading(false);

      if (id) {
        const category = categories.find(
          (item) => item.recordid === id && item.isactive
        );
        if (category) {
          setArticlesList(category.articles || []);
          setCategoryTitle(category.name || "");
          setSearchString(search)
        } else {
          setArticlesList([]);
          setCategoryTitle("");
        }
      }
    }
  }, [categories, id]);

  const handleArticleClick = (articleId) => {
    navigate(`/knowledgebase/document/${articleId}`);
    setSelectedRecordid(articleId);
    setCategoryId(id);
  };

  return (
    <Box
      sx={{ mt: "120px", backgroundColor: COLORS.lightgreenColor, minHeight: "100vh", p: 6 }}
    >
      {/* ✅ Message Row */}
      {!loading && articlesList.length > 0 && (
        <Box sx={{ textAlign: "center", mb: 5 }}>
          <Typography
            sx={{
              fontFamily: fontFamilyAll,
              fontWeight: 500,
              fontSize: "18px",
              color: COLORS.blackColor,
            }}
          >
            Below
            {" "}   <b>{articlesList.length} article{articlesList.length > 1 ? "s" : ""}</b> found in the{" "}
            <b>{categoryName}</b> category for "<b>{searchString}</b>" search.
          </Typography>
        </Box>


      )}

      {/* ✅ Cards Row */}
      <Grid container spacing={4} justifyContent="center">
        {loading ? (
          Array.from(new Array(8)).map((_, index) => (
            <Grid item key={index}>
              <StyledSkeletonCard>
                <CardContent sx={{ p: 2 }}>
                  <Skeleton
                    variant="rectangular"
                    width="100%"
                    height={20}
                    sx={{ mb: 1, borderRadius: 1 }}
                  />
                  <Skeleton
                    variant="rectangular"
                    width="100%"
                    height={50}
                    sx={{ borderRadius: 1 }}
                  />
                </CardContent>
              </StyledSkeletonCard>
            </Grid>
          ))
        ) : articlesList.length > 0 ? (
          <>
            {articlesList.map((article, idx) => (
              <Grid item key={idx}>
                <StyledCard
                  onClick={() => handleArticleClick(article.articleId)}
                >
                  <CardContent sx={{ p: 2 }}>
                    <Typography
                      sx={{
                        fontFamily: fontFamilyAll,
                        fontWeight: 600,
                        color: "black",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      {article.articleName}
                    </Typography>
                  </CardContent>
                </StyledCard>
              </Grid>
            ))}
          </>
        ) : (
          <Grid item xs={12}>
            <Box
              sx={{
                textAlign: "center",
                fontFamily: fontFamilyAll,
                fontSize: "16px",
                fontWeight: 600,
                color: "gray",
                mt: 4,
              }}
            >
              <SearchOffIcon sx={{ fontSize: 40, mb: 1 }} />
              <div>No articles found</div>
            </Box>
          </Grid>
        )}
      </Grid>
    </Box>
  );
}

export default ArticlePage;
